import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, Car, ShoppingBag, Ship, Anchor, Receipt, Wrench, Fuel,
  CircleDot, TrendingUp, Key, Users, Building2, CreditCard, HandCoins,
  CalendarCheck, Calculator, Landmark, BarChart3, Percent, FileText,
  UserCheck, Settings, Wallet,
} from "lucide-react";
import { useAuth } from "../context/AuthContext";

const ALL = ["admin", "direction", "comptable", "commercial", "gestionnaire", "location", "caissier", "mecanicien"];

const MENU = [
  { to: "/", label: "Tableau de bord", icon: LayoutDashboard, roles: ALL, end: true },
  { to: "/vehicules", label: "Véhicules", icon: Car, roles: ["admin", "gestionnaire", "mecanicien", "commercial", "location", "direction"] },
  { to: "/achats", label: "Achats", icon: ShoppingBag, roles: ["admin", "gestionnaire", "comptable", "direction"] },
  { to: "/importations", label: "Importations", icon: Ship, roles: ["admin", "gestionnaire", "direction"] },
  { to: "/port-douane", label: "Port & Douane", icon: Anchor, roles: ["admin", "gestionnaire"] },
  { to: "/depenses", label: "Dépenses", icon: Receipt, roles: ["admin", "comptable", "gestionnaire", "direction"] },
  { to: "/entretiens", label: "Entretiens", icon: Wrench, roles: ["admin", "gestionnaire", "mecanicien"] },
  { to: "/carburant", label: "Carburant", icon: Fuel, roles: ["admin", "gestionnaire", "commercial", "mecanicien"] },
  { to: "/pneus", label: "Pneus", icon: CircleDot, roles: ["admin", "gestionnaire", "mecanicien"] },
  { to: "/ventes", label: "Ventes", icon: TrendingUp, roles: ["admin", "commercial", "comptable", "direction"] },
  { to: "/reservations", label: "Réservations", icon: CalendarCheck, roles: ["admin", "commercial", "location"] },
  { to: "/locations", label: "Locations", icon: Key, roles: ["admin", "commercial", "location"] },
  { to: "/clients", label: "Clients", icon: Users, roles: ALL },
  { to: "/fournisseurs", label: "Fournisseurs", icon: Building2, roles: ["admin", "gestionnaire", "comptable", "direction"] },
  { to: "/dettes-fournisseurs", label: "Dettes fournisseurs", icon: Wallet, roles: ["admin", "gestionnaire", "comptable", "direction"] },
  { to: "/credits", label: "Crédits clients", icon: CreditCard, roles: ["admin", "comptable", "commercial", "caissier", "direction"] },
  { to: "/encaissements", label: "Encaissements", icon: HandCoins, roles: ["admin", "comptable", "commercial", "caissier"] },
  { to: "/comptabilite", label: "Comptabilité", icon: Calculator, roles: ["admin", "comptable", "direction"] },
  { to: "/caisse", label: "Caisse & Banque", icon: Landmark, roles: ["admin", "comptable", "caissier", "direction"] },
  { to: "/rapports", label: "Rapports", icon: BarChart3, roles: ["admin", "comptable", "direction"] },
  { to: "/rentabilite", label: "Rentabilité", icon: Percent, roles: ["admin", "comptable", "direction"] },
  { to: "/documents", label: "Documents", icon: FileText, roles: ALL },
  { to: "/utilisateurs", label: "Utilisateurs", icon: UserCheck, roles: ["admin"] },
  { to: "/parametres", label: "Paramètres", icon: Settings, roles: ["admin"] },
];

export function SidebarContent({ onNavigate }) {
  const { user } = useAuth();
  const items = MENU.filter((m) => m.roles.includes(user?.role));
  return (
    <div className="flex h-full flex-col bg-[#0F172A] text-slate-300">
      <div className="flex items-center gap-3 px-5 py-5 border-b border-[#1E293B]">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-cyan-600">
          <Car className="h-5 w-5 text-white" />
        </div>
        <div>
          <p className="font-heading text-base font-bold text-white leading-tight">Sylla Auto Good</p>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto py-3 px-3 space-y-0.5" data-testid="sidebar-menu">
        {items.map((m) => (
          <NavLink
            key={m.to}
            to={m.to}
            end={m.end}
            onClick={onNavigate}
            data-testid={`menu-${m.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors duration-150 ${
                isActive ? "bg-cyan-600 text-white" : "text-slate-400 hover:bg-[#1E293B] hover:text-white"
              }`
            }
          >
            <m.icon className="h-4 w-4 shrink-0" />
            <span>{m.label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-[#1E293B] px-5 py-4">
        <p className="text-xs text-slate-500">Connecté en tant que</p>
        <p className="text-sm font-semibold text-white truncate">{user?.name}</p>
        <p className="text-xs text-cyan-400 capitalize">{user?.role}</p>
      </div>
    </div>
  );
}

export default function Sidebar() {
  return (
    <aside className="fixed inset-y-0 left-0 z-30 hidden w-64 md:block">
      <SidebarContent />
    </aside>
  );
}
